module.exports = __webpack_public_path__ + "img/eicon4.d1f8f5ec.png";